/** Client poll budget while accessState is payment-pending (ADR-0019). */
export const PAYMENT_PENDING_POLL_MAX_MS = 2 * 60 * 1000;

export const PAYMENT_PENDING_POLL_INTERVAL_MS = 15_000;

export function shouldContinuePaymentPendingPoll(startedAtMs: number, nowMs: number = Date.now()): boolean {
  return nowMs - startedAtMs < PAYMENT_PENDING_POLL_MAX_MS;
}
